import { Component, Input } from '@angular/core';
import { CiType } from '../../models/ci-type';
import { AnalysisToolTip } from '../../models/analysis-tool-tip.model';
import { SearchTextHighlight } from '../../models/advance-search/search-text-highlight.model';

@Component({
    selector: 'dop-analyses-tool-tip',
    templateUrl: './analyses-tool-tip.component.html',
    styleUrls: ['./analyses-tool-tip.component.scss']
})
export class AnalysesToolTipComponent {

    @Input() toolTipData: AnalysisToolTip;
    @Input() searchTexts: SearchTextHighlight = new SearchTextHighlight();

    constructor() {
    }

    get ciTypes() { return CiType; }

    isDisplayHoverLOD() {
        return this.toolTipData.parameters.some((p: any) => p.lod);
    }

    isDisplayHoverLOQ() {
        return this.toolTipData.parameters.some((p: any) => p.loq);
    }

    isDisplayHoverCASNumber() {
        return this.toolTipData.parameters.some((p: any) => p.casIdentifier);
    }
}
